import { View, StyleSheet, Text, Page, Image, Font } from "@react-pdf/renderer";
import { ClpData } from "../../../../../../models/Clp";
import { Table, TableColumn, TableRow } from "../../../../FAR/Table";
import { useTranslation } from "react-i18next";

const styles = StyleSheet.create({
  page: {
    padding: 10,
  },
  tableRow: {
    backgroundColor: "#EFF1F5",
    textTransform: "uppercase",
    fontSize: "8px",
    fontWeight: 700,
    padding: 8,
    fontStyle: "Manrope",
  },
  doneLabel: {
    color: "#606F89",
    fontSize: "6px",
    display: "flex",
    width: "6%",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
  },

  clpDataContainer: {
    marginBottom: "10px",
    borderBottom: "1px solid lightgray",
  },

  clpData: {
    display: "flex",
    flexDirection: "row",
    margin: "5px",
  },
  checkbox: {
    border: "1px solid #DDE1E6",
    width: "12px",
    height: "12px",
  },

  image: {
    width: "auto",
    height: "150px",
    margin: 10,
  },
  mandatoryLabelView: {
    backgroundColor: "#1672EC",
    color: "white",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "4px",
    fontWeight: 700,
    fontSize: "8px",
    height: "20px",
  },
  table: {
    marginTop: "15px",
  },
  tableRowClp: {
    backgroundColor: "white",
  },
  tableColumnDescription: {
    borderLeft: 0,
    width: "82%",
    padding: 6,
    fontFamily: "Manrope",
    fontSize: "9px",
  },
  tableColumnMandatory: {
    width: "12%",
    padding: 6,
  },
  tableColumnCheckbox: {
    width: "6%",
    padding: 6,
    textAlign: "center",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  footer: {
    position: "absolute",
    bottom: 15,
    width: "100%",
  },
  accessibilityLogoImage: {
    backgroundColor: 'white',
    left: 0,
    width: "auto",
    height: "25px",
    objectFit: "contain",
  },
  pageNumber: {
    fontSize: 12,
    color: "#1B2635",
  }
});

Font.register({
  family: "Manrope",
  src: `${process.env.PUBLIC_URL}/static/fonts/Manrope-Medium.ttf`,
});

Font.register({
  family: "Manrope",
  src: `${process.env.PUBLIC_URL}/static/fonts/Manrope-Bold.ttf`,
});

const MandatoryLabel = () => {
  const { t } = useTranslation();
  return (
    <View style={styles.mandatoryLabelView}>
      <Text>
        {t("CLP_UnitMandatoryLabel")}
      </Text>
    </View>
  );
};
const CheckBox = () => {
  return <View style={styles.checkbox}></View>;
};
export const UnitContainer = (p: {
  data: [string, ClpData[]];
  property: string;
}) => {
  const { t } = useTranslation();
  const {
    data: [title, clpData],
    property: propertyName,
  } = p;

  return (
    <>
      <View>
        {clpData.map((entry, i) => {
          return (
            <Table
              key={i}
              style={styles.table}
            >
              <TableRow style={styles.tableRow}>
                <Text>
                  {entry.title} - {entry.name}
                </Text>
              </TableRow>

              {entry.clps.filter((clp) => !clp.is_done).map((clp, clpIndex) => {
                return (
                  <TableRow
                    key={clpIndex}
                    style={styles.tableRowClp}
                  >
                    <TableColumn style={styles.tableColumnDescription}>
                      <Text>{clp.q_title}</Text>
                    </TableColumn>
                    <TableColumn style={styles.tableColumnMandatory}>
                      {clp.is_mandatory && <MandatoryLabel />}
                    </TableColumn>
                    <TableColumn style={styles.tableColumnCheckbox}>
                      <CheckBox />
                    </TableColumn>
                  </TableRow>
                );
              })}
            </Table>
          );
        })}
      </View>
      <View
        // fixed
        style={styles.footer}
      >
        <View
          style={{
            position: "absolute",
            bottom: 0,
            left: styles.page.padding,
          }}
        >
          <Image
            style={styles.accessibilityLogoImage}
            src={`${process.env.PUBLIC_URL}/static/img/icons/HD-accessibility-logo-footer-2.0.png`}
          />
        </View>
        <View
          style={{
            position: "absolute",
            bottom: 0,
            right: -styles.page.padding,
          }}
        >
          <Text
            style={styles.pageNumber}
            render={({ pageNumber }) => `${pageNumber - 1}`}
          />
        </View>
      </View>
    </>
  );
};
